let winScollTop = 0;
let windowHeight = window.innerHeight;

export const isInViewport = (sections, functions) => {

	if (! sections.length) {
		return;
	}

	winScollTop = window.scrollY;

	for (const section of sections) {
		const sectionHeight = section.clientHeight;
		const sectionOffestTop = section.getBoundingClientRect().top + window.scrollY;
		const isVisible = winScollTop + windowHeight >= sectionOffestTop + (sectionHeight * 0.5);
		const isAnimated = section.classList.contains('is-animated');

		if (!isVisible || isAnimated) {
			continue;
		};

		const functionality = section.dataset.functionality;

		section.classList.add('is-animated');

		functions[functionality]();
	}
};

window.addEventListener('resize', () => {
	windowHeight = window.innerHeight;
});

window.addEventListener('orientationchange', () => {
	windowHeight = window.innerHeight;
});
